/**
 * @nanokart/tryon-studio-sdk
 * Static Items Provider
 * 
 * Simple provider that returns pre-defined items.
 * Used for single-item mode and embedded-commerce.
 */

import { CatalogItem, CatalogFilters, CatalogPagination, CatalogResult } from '../../types/config';
import { CatalogProvider, ProviderCapabilities } from './types';

export class StaticItemsProvider implements CatalogProvider {
  private items: CatalogItem[];

  constructor(items: CatalogItem[] = []) {
    this.items = items;
  }

  capabilities: ProviderCapabilities = {
    supportsFiltering: false,
    supportsPagination: false,
    supportsSearch: false,
  };

  async list(_filters?: CatalogFilters, _pagination?: CatalogPagination): Promise<CatalogResult> {
    return {
      items: this.items,
      total: this.items.length,
      hasMore: false,
    };
  }

  async getById(productId: string): Promise<CatalogItem | null> {
    return this.items.find((item) => item.productId === productId) ?? null;
  }

  async search(_query: string, _pagination?: CatalogPagination): Promise<CatalogResult> {
    // Static provider doesn't support search, return all items
    return this.list();
  }

  /**
   * Update items (for dynamic updates via vanilla API)
   */
  setItems(items: CatalogItem[]): void {
    this.items = items;
  }

  /**
   * Get current items
   */
  getItems(): CatalogItem[] {
    return this.items;
  }
}
